import { Form } from '@/components';
import { useBool } from '@/utils';
import { useHomeLookupSource } from '@/views';
import { Button, Divider, Row } from 'antd';
import { useField } from 'formik';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

interface HomeInputProps {
  communityId: string;
  projectId: string;
  name: string;
  isTemplate?: boolean;
  onChanged?: (homeIds: string[]) => void;
}

export function HomeInput(props: HomeInputProps) {
  const { communityId, name, projectId, isTemplate, onChanged } = props;
  const homeDataSource = useHomeLookupSource(communityId, projectId);
  const [optionKeys, setOptionKeys] = useState<string[]>([]);

  const [, { value: selectedHomeIds }, { setValue }] = useField<string[]>(
    `${name}.homeIds`,
  );

  useEffect(() => {
    isTemplate && onChanged && onChanged(selectedHomeIds);
  }, [selectedHomeIds, isTemplate, name, onChanged]);

  const { t } = useTranslation();

  const [allSelected, setAllSelected, toggleAllSelected] = useBool(false);

  const handleAllSelect = () => {
    if (allSelected) {
      setValue([]);
    } else {
      setValue(optionKeys);
    }
    toggleAllSelected();
  };

  useEffect(() => {
    if (selectedHomeIds) {
      setAllSelected(selectedHomeIds.length === optionKeys.length);
    }
  }, [
    selectedHomeIds,
    isTemplate,
    name,
    onChanged,
    optionKeys,
    setAllSelected,
  ]);

  return (
    <Form.AsyncSelect
      name={`${name}.homeIds`}
      dataSource={homeDataSource}
      label={false}
      preload
      mode="multiple"
      onSearchLoad={(options) => {
        setOptionKeys(options.map((x) => x.value));
      }}
      dropdownRender={(menu) => (
        <>
          {menu}

          <>
            <Divider style={{ margin: '2px' }} />
            <Row justify="center" className="p-2">
              <Button type="link" onClick={handleAllSelect}>
                {t(
                  `personalization.${
                    allSelected ? 'unselectAll' : 'selectAll'
                  }`,
                )}
              </Button>
            </Row>
          </>
        </>
      )}
    />
  );
}
